var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M252.35 345.9c-38.17 18.78-65.34 28-72.08 22.34s-3.12-34.66 7.48-76.3c17.89 2 32.57 6.34 41.4 13.6 9.44 7.79 17.22 22.22 23.2 40.36z",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M290.72 500.33a34.17 34.17 0 01-5.92 6.44s0 .05-.09.1c-11.18 9.22-22.68 4.19-20.38-12.1 6.45-44.39 2.08-106.64-12-148.87-6-18.14-13.76-32.57-23.2-40.36-8.83-7.26-23.51-11.63-41.4-13.6-44.07-5.05-107.67 4.35-151.13 20.4-18.17 6.78-25-8.89-11.09-24.78 3.89-4.47 8.21-9.14 12.93-13.89 105.75-107.55 411.11-292 436.05-271 26.01 21.98-101.98 387.2-183.77 497.66z",
    fill: "#fff"
  })));
}

export default SvgIconWhite;